/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchScanResultsResponse } from './search-scan-results-response';


export interface SearchScanResultsResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchScanResultsResponse> | null;
}

